import React, { useState } from "react";
import { Dna } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import "../../css/main.css";
import { getChangePassword } from "../../redux/action";

function ChangePassword() {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.ChangePassword);
  const [OldPassword, setOldPassword] = useState({
    value: "",
    error: "Old Password is invalid",
    isTouched: false,
  });
  const [NewPassword, setNewPassword] = useState({
    value: "",
    error: "New Password is invalid",
    isTouched: false,
  });
  const [ConfirmPassword, setConfirmPassword] = useState({
    value: "",
    error: "Confirm New Password is invalid",
    isTouched: false,
  });
  const req = async () => {
    if ((OldPassword.value, NewPassword.value, ConfirmPassword.value)) {
      if (NewPassword.value === ConfirmPassword.value) {
        dispatch(getChangePassword(OldPassword.value, NewPassword.value));
        if (data) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Password changed successfully",
            showConfirmButton: false,
            timer: 3000,
          });
        } else if (error) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: error.response.data.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } else {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Password confirmation is wrong",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    } else {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Please complete all fields",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };
  //////////////////////////////////////////////////////////////
  function eye() {
    const OldPassword = document.querySelector("#OldPassword");
    const NewPassword = document.querySelector("#NewPassword");
    const ConfirmPassword = document.querySelector("#ConfirmPassword");
    if (OldPassword.type === "password") {
      OldPassword.type = "text";
      NewPassword.type = "text";
      ConfirmPassword.type = "text";
    } else if (OldPassword.type === "text") {
      OldPassword.type = "password";
      NewPassword.type = "password";
      ConfirmPassword.type = "password";
    }
  }
  //////////////////////////////////////////////////////////////
  return (
    <div className="w-full">
      {loading ? (
        <div className="mt-32 flex justify-center">
          <Dna
            visible={true}
            height="150"
            width="150"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : error ? (
        <div className="flex justify-center">
          <div className="alert alert-error shadow-lg w-8/12 mt-20">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>Error! Task failed successfully.</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="sm:flex -ml-96 w-80 sm:w-80 sm:-ml-56 md:w-80 md:-ml-12 lg:w-10/12 lg:ml-5 xl:w-7/12 xl:ml-32 2xl:w-4/12 2xl:ml-96">
          <div className="card w-full bg-primary text-primary-content mt-72 sm:mt-32 shadow-lg">
            <div className="card-body text-black dark:text-slate-100">
              {/* /////////////Old Password//////////////// */}
              <input
                type="password"
                id="OldPassword"
                placeholder="Old Password"
                className="input input-bordered input-primary w-full text-center mb-5"
                onChange={(e) =>
                  setOldPassword((last) => {
                    const help = { ...last };
                    help.value = e.target.value;
                    return { ...help };
                  })
                }
                onBlur={() => {
                  setOldPassword((last) => {
                    const help = { ...last };
                    help.isTouched = true;
                    return { ...help };
                  });
                }}
              />
              {!/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(
                OldPassword.value
              ) &&
                OldPassword.isTouched && (
                  <span className="absolute top-20">{OldPassword.error}</span>
                )}
              {/* /////////////New Password//////////////// */}
              <input
                type="password"
                id="NewPassword"
                placeholder="New Password"
                className="input input-bordered input-primary w-full text-center mb-5"
                onChange={(e) =>
                  setNewPassword((last) => {
                    const help = { ...last };
                    help.value = e.target.value;
                    return { ...help };
                  })
                }
                onBlur={() => {
                  setNewPassword((last) => {
                    const help = { ...last };
                    help.isTouched = true;
                    return { ...help };
                  });
                }}
              />
              {!/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(
                NewPassword.value
              ) &&
                NewPassword.isTouched && (
                  <span className="absolute top-[157px]">
                    {NewPassword.error}
                  </span>
                )}
              {/* /////////////confirm Password//////////////// */}
              <input
                type="password"
                id="ConfirmPassword"
                placeholder="Confirm New Password"
                className="input input-bordered input-primary w-full text-center mb-5"
                onChange={(e) =>
                  setConfirmPassword((last) => {
                    const help = { ...last };
                    help.value = e.target.value;
                    return { ...help };
                  })
                }
                onBlur={() => {
                  setConfirmPassword((last) => {
                    const help = { ...last };
                    help.isTouched = true;
                    return { ...help };
                  });
                }}
              />
              {!/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(
                ConfirmPassword.value
              ) &&
                ConfirmPassword.isTouched && (
                  <span className="absolute top-[227px]">
                    {ConfirmPassword.error}
                  </span>
                )}
              <div className="card-actions justify-evenly mt-5">
                <button className="btn sm:w-5/12 lg:w-4/12" onClick={req}>
                  done
                </button>
              </div>
              {/* ////////////////////eye////////////////////// */}
              <div
                className="absolute top-[115px] right-0 w-8 mr-2 bg-slate-500 rounded-full cursor-pointer hover:scale-105 border-2 border-black"
                onClick={() => eye()}
              >
                <img src="https://img.icons8.com/external-creatype-two-colour-colourcreatype/64/null/external-eyes-basic-creatype-two-colour-colourcreatype-4.png" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ChangePassword;
